"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiFeatureBuyTotalBetIndicator = void 0;
var _core = require("@dragon/core");
var _pixi = require("pixi.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _superPropGet(t, e, r, o) { var p = _get(_getPrototypeOf(1 & o ? t.prototype : t), e, r); return 2 & o ? function (t) { return p.apply(r, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for building and displaying the total value of the feature buy bet.
 */
var PixiFeatureBuyTotalBetIndicator = exports.PixiFeatureBuyTotalBetIndicator = /*#__PURE__*/function (_Container) {
  function PixiFeatureBuyTotalBetIndicator(pStyle, vStyle) {
    var _this;
    _classCallCheck(this, PixiFeatureBuyTotalBetIndicator);
    _this = _callSuper(this, PixiFeatureBuyTotalBetIndicator);
    _defineProperty(_this, "valueSub", void 0);
    _defineProperty(_this, "valueSub2", void 0);
    /**
    * The Text, exposed to allow for adjustments on pos
    */
    _defineProperty(_this, "text", void 0);
    /**
     * The value, exposed to allow for adjustments on pos
     */
    _defineProperty(_this, "value", void 0);
    _defineProperty(_this, "refresh", function () {
      var _state$featureBuy$cur;
      var state = _core.CORE.getState();
      if ((_state$featureBuy$cur = state.featureBuy.currentFeatureTrigger) !== null && _state$featureBuy$cur !== void 0 && _state$featureBuy$cur.betMulitiplier) {
        var value = state.bet.centValue / 100 * state.featureBuy.currentFeatureTrigger.betMulitiplier;
        if (value) _this.value.text = (0, _core.currencyFormatter)(value, state.balance.currency);
      }
    });
    _defineProperty(_this, "destroy", function () {
      _this.valueSub();
      _this.valueSub2();
      _superPropGet((_this, PixiFeatureBuyTotalBetIndicator), "destroy", _this, 3)([]);
    });
    _this.text = new _pixi.Text(_core.CORE.translate("fbdTotalBet"), pStyle);
    _this.text.anchor.set(0.5);
    _this.text.y = 70;
    var valueBackground = new _pixi.Sprite(_pixi.Texture.from('fb_valuebg.png'));
    valueBackground.anchor.set(0.5);
    valueBackground.y = 20;
    _this.value = new _pixi.Text("", vStyle);
    _this.value.anchor.set(0.5);
    _this.value.y = 18;
    _this.valueSub = _core.CORE.subscribe('bet.centValue', function (e) {
      _this.refresh();
    });
    _this.valueSub2 = _core.CORE.subscribe('featureBuy.currentFeatureTrigger', function (e) {
      _this.refresh();
    });
    _this.addChild(valueBackground, _this.value, _this.text);
    return _this;
  }
  _inherits(PixiFeatureBuyTotalBetIndicator, _Container);
  return _createClass(PixiFeatureBuyTotalBetIndicator);
}(_pixi.Container);
//# sourceMappingURL=PixiFeatureBuyTotalBetIndicator.js.map